<template>
	<div id="content">
		<shutter-panel ref="shutterPanel" />
	</div>
</template>

<script type="text/javascript">
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"

	export default {
		name: 'TiersStocks',
		mixins: [ShutterCongelation],
		props: ['tiers_id'],
		mounted() {
			this.setUpTiersStocksListe(this.tiers_id)
		},
	}
</script>